// From MCard
export const DATA_TYPE_MULTI_LINE_STRING = "DATA_TYPE_MULTI_LINE_STRING";
export const DATA_TYPE_NUMBER = "DATA_TYPE_NUMBER";
export const DATA_TYPE_NUMBER_HUNDREDTHS = "DATA_TYPE_NUMBER_HUNDREDTHS";
export const DATA_TYPE_NUMBER_TENTHS = "DATA_TYPE_NUMBER_TENTHS";
export const DATA_TYPE_NUMBER_UNFORMATTED = "DATA_TYPE_NUMBER_UNFORMATTED";
export const DATA_TYPE_PERCENT = "DATA_TYPE_PERCENT"; // Use this data type if you want 50.00 to be formatted as 50.00%
export const DATA_TYPE_PERCENT_WHOLE_NUMBER = "DATA_TYPE_PERCENT_WHOLE_NUMBER"; // Use this data type if you want 50.00 to be formatted as 50%
export const DATA_TYPE_PHONE_NUMBER = "DATA_TYPE_PHONE_NUMBER";
export const DATA_TYPE_MONEY = "DATA_TYPE_MONEY";
export const DATA_TYPE_BOOLEAN = "DATA_TYPE_BOOLEAN";
export const DATA_TYPE_DATE = "DATA_TYPE_DATE";
export const DATA_TYPE_DATE_TIME = "DATA_TYPE_DATE_TIME";
export const DATA_TYPE_TIME = "DATA_TYPE_TIME";
export const DATA_TYPE_DAYS_ELAPSED = "DATA_TYPE_DAYS_ELAPSED";
export const DATA_TYPE_DROPDOWN = "DATA_TYPE_DROPDOWN";
export const DATA_TYPE_DROPDOWN2 = "DATA_TYPE_DROPDOWN2"; // Improved version of dropdown that we will eventually replace dropdown with
export const DATA_TYPE_EMAIL = "DATA_TYPE_EMAIL";
export const DATA_TYPE_APPRAISER = "DATA_TYPE_APPRAISER";
export const DATA_TYPE_ADDRESS = "DATA_TYPE_ADDRESS";
export const DATA_TYPE_COUNTY = "DATA_TYPE_COUNTY";
export const DATA_TYPE_GEOCODE = "DATA_TYPE_GEOCODE";
export const DATA_TYPE_DATE_DOW = "DATA_TYPE_DATE_DOW";
export const DATA_TYPE_DATE_TIME_DOW = "DATA_TYPE_DATE_TIME_DOW";
export const DATA_TYPE_HYPERLINK = "DATA_TYPE_HYPERLINK";
export const DATA_TYPE_PASSWORD = "DATA_TYPE_PASSWORD";
export const DATA_TYPE_ADDRESS_AUTOCOMPLETE = "DATA_TYPE_ADDRESS_AUTOCOMPLETE";
export const DATA_TYPE_JSX = "DATA_TYPE_JSX";
export const DATA_TYPE_CREDIT_CARD = "DATA_TYPE_CREDIT_CARD";
export const DATA_TYPE_NUMBER_STRING = "DATA_TYPE_NUMBER_STRING";
export const DATA_TYPE_PERCENT_DECIMAL = "DATA_TYPE_PERCENT_DECIMAL"; // Use this data type if you want 0.5 to be formatted as 50%
export const DATA_TYPE_NUMBER_NEGATIVE_OR_POSITIVE = "DATA_TYPE_NUMBER_NEGATIVE_OR_POSITIVE";
export const DATA_TYPE_NODE = "DATA_TYPE_NODE";

// From MGridForm
// MGridForm implements many of the MCard types above, see component for details
export const DATA_TYPE_NONE = "DATA_TYPE_NONE";
export const DATA_TYPE_STRING = "DATA_TYPE_STRING";
export const DATA_TYPE_CHECKBOX = "DATA_TYPE_CHECKBOX";
export const DATA_TYPE_RADIO = "DATA_TYPE_RADIO";
export const DATA_TYPE_SPLIT_RADIO = "DATA_TYPE_SPLIT_RADIO"; // Split radio acts like a radio box only across multiple fields as long as they share the same source
export const DATA_TYPE_PHOTO = "DATA_TYPE_PHOTO";
export const DATA_TYPE_ZIP = "DATA_TYPE_ZIP";
export const DATA_TYPE_YEAR = "DATA_TYPE_YEAR";
export const DATA_TYPE_TOOLTIP = "DATA_TYPE_TOOLTIP";

// From MGrid
// MGrid implements many of the types above, see component for details
// If adding a data type here, please add it to the comparer(a, b) function in MGrid
export const DATA_TYPE_NUMBER_RAW = "DATA_TYPE_NUMBER_RAW";
export const DATA_TYPE_DATETIME_WITHDOW = "DATA_TYPE_DATETIME_WITHDOW";
export const DATA_TYPE_DATE_WITHDOW = "DATA_TYPE_DATE_WITHDOW";
export const DATA_TYPE_BUTTON = "DATA_TYPE_BUTTON";
export const DATA_TYPE_TEXT_BUTTON = "DATA_TYPE_TEXT_BUTTON";